import { gql, useQuery } from '@apollo/client';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import { get, map } from 'lodash';

import { AppHeader } from '../../components/header';

import './style.scss';

const GET_CATEGORIES = gql`
  query getCategories {
    categories {
      id
      name
      key
    }
  }
`;

export const CatalogListView = () => {
  const { data, error } = useQuery(GET_CATEGORIES, {
    fetchPolicy: 'cache-and-network',
  });
  const categories = get(data, 'categories');

  if (error) {
    console.error(error);
  }

  return (
    <div className="catalog-view">
      <AppHeader title="BALEO" />
      <div className="catalog-list">
        {Boolean(error) && <div>Une erreur est survenue.</div>}
        {map(categories, (cat) => (
          <Link key={cat.key} to={`/catalog/${cat.key.replace(/\//g, '%2F')}`}>
            <div className="catalog-item">
              <div className="catalog-item-name">{cat.name}</div>
              <FontAwesomeIcon
                className="catalog-item-arrow"
                icon={faArrowRight}
              />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
